import { SocialIcon } from 'design-system/components/Icon';
import { ComponentPropsWithoutRef, useRef } from 'react';

type FacebookShareButtonProps = ComponentPropsWithoutRef<'div'> & {
  href: string;
};

const FacebookShareButton = (props: FacebookShareButtonProps) => {
  const { href, ...restProps } = props;
  const ref = useRef<HTMLDivElement>(null);

  ref.current?.addEventListener('click', (e) => {
    e.preventDefault();
    window.open(
      ref.current?.attributes.getNamedItem('href')?.value,
      'fbShareWindow',
      'height=450, width=550, top=' +
        (window.innerHeight / 2 - 275) +
        ', left=' +
        (window.innerWidth / 2 - 225) +
        ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
    );
    return false;
  });

  return (
    <a
      ref={ref as any}
      rel="noreferrer"
      href={`https://www.facebook.com/sharer/sharer.php?u=${href}`}
      target="_blank"
    >
      <SocialIcon iconName="facebook" />
    </a>
  );
};

export default FacebookShareButton;
